import React from "react";
import { Input, TextArea } from "semantic-ui-react";
import OptionButton from "slides/components/OptionButton.react";

export default class InputField extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            answer: "",
        };
    }
    changeText = (event) => {
        this.setState({ answer: event.target.value });
    };

    render() {
        // let isPortrait =
        //     this.props.mobileView || window.innerHeight > window.innerWidth;
        let componentStyles = {
            default: { marginBottom: "0.5em", width: "100%" },
            grid: { marginBottom: "0.5em", width: "100%" },
        };

        return (
            <div>
                {this.props.smallField && (
                    <Input
                        fluid
                        placeholder={this.props.placeholder}
                        onChange={this.changeText}
                        style={componentStyles[this.props.layout]}
                    />
                )}
                {!this.props.smallField && (
                    <TextArea
                        rows="10"
                        placeholder={this.props.placeholder}
                        onChange={this.changeText}
                        style={{
                            ...componentStyles[this.props.layout],
                            padding: "10px",
                        }}
                    />
                )}
                <OptionButton
                    {...this.props}
                    secondary={true}
                    name="Submit"
                    handleClick={() =>
                        this.props.handleClick(this.state.answer)
                    }
                />
            </div>
        );
    }
}
